import DefaultLayout from "@/layouts/DefaultLayout";
import KEmployeeInjuryReportForm from "kinnect-front/KSafety/Injuries/KEmployeeInjuryReportForm";
import { Crudable, FetchesData, Pageable } from "kinnect-mixins";
import { SafetyEmployeeInjuryReport } from "kinnect-models";

export default {
	name: "SafetyEmployeeInjuryReportPage",

	metaInfo() {
		const title = this.editing
			? "Safety - Employee Injury Reports - Edit Report"
			: "Safety - Employee Injury Reports - File a Report";

		return { title };
	},

	props: { idReport: Number },

	mixins: [
		Crudable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		crud: "safety_employee_injury_reports",
		report: null
	} ),

	computed: {
		editing() {
			return Boolean( this.idReport );
		}
	},

	methods: {
		async fetchReport() {
			if ( this.editing ) {
				this.report = await SafetyEmployeeInjuryReport.findPageModel( this.idReport );
			}
		},

		async fetch() {
			await this.fetchReport();
		}
	},

	render() {
		return <DefaultLayout maxWidth="800px">
			<KEmployeeInjuryReportForm
				loading={this.$wait.is( "find employee injury report" )}
				readonly={this.editing ? !this.canEdit : !this.canAdd}
				report={this.report}
			></KEmployeeInjuryReportForm>
		</DefaultLayout>;
	}
};
